import { vidToString } from './util';
export const defKey = (def) => {
    switch (def.kind) {
        case 'module':
            return def.kind + vidToString(def.identifier);
        case 'self':
            return def.kind;
        case 'name-def':
        case 'fn-def':
        case 'trait-def':
        case 'type-def':
        case 'generic':
            return def.kind + def.name.value;
        case 'method-def':
            return 'fn-def' + def.fn.name.value;
        case 'impl-def':
            return def.kind + def.identifier.names.at(-1).value;
        case 'variant':
            return def.kind + def.variant.name.value;
    }
};
export const pathToVid = (path, packageName) => {
    const dirs = path.replace(/\.no$/, '').split('/');
    if (packageName) {
        dirs.unshift(packageName);
    }
    if (dirs.at(-1).toLowerCase() === 'mod') {
        dirs.pop();
    }
    return { names: dirs };
};
export const unwindScope = (ctx) => {
    const module = ctx.moduleStack.at(-1);
    return module.scopeStack.toReversed();
};
export const instanceScope = (ctx) => {
    return unwindScope(ctx).find(s => s.kind === 'instance');
};
export const instanceRelation = (instanceDef, ctx) => {
    return ctx.impls.find(i => i.instanceDef === instanceDef);
};
export const fnDefScope = (ctx) => {
    return unwindScope(ctx).find(s => s.kind === 'fn');
};
export const addError = (ctx, error) => {
    if (!ctx.silent) {
        // console.trace(
        //     prettySourceMessage(error.message, getSpan(error.node.parseNode), error.module.source, error.notes)
        // )
        ctx.errors.push(error);
    }
};
export const addWarning = (ctx, error) => {
    if (!ctx.silent) {
        ctx.warnings.push(error);
    }
};
export const enterScope = (module, scope, ctx) => {
    module.scopeStack.push(scope);
};
export const leaveScope = (module, ctx) => {
    // TODO: check malleable closures getting out of scope
    module.scopeStack.pop();
};
//# sourceMappingURL=index.js.map